
    import {Component, Prop, Vue} from 'vue-property-decorator'

    @Component
    export default class CommonLabel extends Vue {
        @Prop({ default: 10 }) size!: number;
        @Prop({ default: '#015BFF' }) color!: string;
    }
